<template>
    <form-row title="Type" :no_border="true" class="mt-8">
        <input-text
            class="flex-1"
            :value="insurance.insurance_type"
            name="insurance_type"
            :read_only="read_only"
        />
    </form-row>
</template>

<script>
export default {
    props: {
        insurance: {},
        read_only: { default: false },
    },
}
</script>
